export const INIT_ALERT_LIST_REQUEST = 'INIT_ALERT_LIST_REQUEST';
export const SET_ALERT_LIST = 'SET_ALERT_LIST';
export const APPEND_ALERT_LIST = 'APPEND_ALERT_LIST';
export const ERROR_ALERT_LIST = 'ERROR_ALERT_LIST';
export const DELETE_ALERT = 'DELETE_ALERT';
export const ERROR_ALERT_REQUEST = 'ERROR_ALERT_REQUEST';

export const initAlertListRequest = () => ({
  type: INIT_ALERT_LIST_REQUEST
});

export const setAlertList = (data) => ({
  type: SET_ALERT_LIST,
  payload: data
});

export const appendAlertList = (data) => ({
  type: APPEND_ALERT_LIST,
  payload: data
});

export const errorAlertList = (message) => ({
  type: ERROR_ALERT_LIST,
  payload: message
});

export const deleteAlert = (alertId) => ({
  type: DELETE_ALERT,
  payload: alertId
});

export const errorAlertRequest = (message) => ({
  type: ERROR_ALERT_REQUEST,
  payload: message
});

